import React from "react";
import "./Status.css";

const Status = ({ status, text, size }) => {
  let statusColor = "";
  let statusTextColor = "";
  switch (status) {
    case "completed":
    case "Completed":
    case "active":
    case "New":
    case "Approved":
    case "Paid":
      statusColor = "rgba(52, 191, 163, 0.2)";
      statusTextColor = "#25A48A";
      break;

    case "pending":
    case "Pending":
    case "Low in Stock":
    case "Delivered":
    case "Received":
    case "Sent":
      statusColor = "rgba(254, 168, 14, 0.2)";
      statusTextColor = "#EC9800";
      break;

    case "Out of Stock":
    case "Canceled":
    case "OverDue":
    case "Rejected":
    case "Inactive":
      statusColor = "rgba(255, 98, 113, 0.2)";
      statusTextColor = "#FF6271";
      break;

    case "In progress":
    case "Delivering":
      statusColor = "rgba(54, 163, 247, 0.18)";
      statusTextColor = "#36A3F7";
      break;

    default:
      statusColor = "rgba(52, 191, 163, 0.2)";
      statusTextColor = "#25A48A";
      break;
  }
  return (
    <div
      className="statusBox"
      style={{
        background: statusColor,
        width: size === "xs" ? "80px" : "164px",
      }}
    >
      <span style={{ color: statusTextColor, opacity: 1 }}>{text}</span>
    </div>
  );
};

export default Status;
